import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {useTranslation} from 'react-i18next';
import {API} from '@chekin/api';

function useEsimInstructions({id}: {id: string}) {
  const {i18n} = useTranslation();

  const result = useQuery({
    queryKey: [QUERY_CACHE_KEYS.esims, id, i18n.language],
    queryFn: () => API.upselling.getEsimInstructions(id),
    enabled: Boolean(id),
  });

  return result;
}

export {useEsimInstructions};
